import ContentBox from "../../../components/atoms/ContentBox";
import { BreadcrumbsView } from "../../../components/general/BreadcrumbsView";
import { MultiSectionBatch } from "../useMultiSectionBatchesDetail";
import { Failure } from "./Failure";
import { getMultiSectionBatchInfo } from "./getMultiSectionBatchInfo";
import { Pending } from "./Pending";
import { Success } from "./Success";
import { UpdateDrillDetail } from "./UpdateDrillDetail";
import { UploadDrillDetail } from "./UploadDrillDetail";

type Props = {
  batch: MultiSectionBatch;
  fromRegistration: boolean;
};

const DownloadStatus = ({
  batch,
  dataTypeLabel,
  fileNamePrefix,
}: {
  batch: MultiSectionBatch;
  dataTypeLabel: string;
  fileNamePrefix: string;
}) => {
  switch (batch.status) {
    case "standby":
    case "processing":
      return <Pending dataTypeLabel={dataTypeLabel} />;
    case "success":
      return (
        <Success
          batch={batch}
          dataTypeLabel={dataTypeLabel}
          fileNamePrefix={fileNamePrefix}
        />
      );
    case "failure":
      return <Failure dataTypeLabel={dataTypeLabel} />;
    default:
      throw "エラーが発生しました";
  }
};

export const Detail = ({ batch, fromRegistration }: Props) => {
  const { batchTypeHuman, Icon } = getMultiSectionBatchInfo(batch.batchType);

  const isDrill =
    batch.batchType === "upload_drill" || batch.batchType === "update_drill";

  const breadcrumbItems = isDrill
    ? [
        { label: "校舎横断操作", url: "/multi_section_batches" },
        {
          label: "デジタル教材の登録",
          url: "/multi_section_batches/upload_drill/history",
        },
        { label: "操作履歴の詳細" },
      ]
    : [
        { label: "校舎横断操作", url: "/multi_section_batches" },
        { label: batchTypeHuman },
      ];

  if (isDrill) {
    return (
      <div className="flex md:w-[90%] flex-col">
        <div className="py-5">
          <BreadcrumbsView items={breadcrumbItems} />
        </div>
        <ContentBox className="md:w-[80%] md:p-10">
          <div className="flex items-center gap-6">
            <Icon className="h-[3rem] w-[3rem] text-gray-600" />
            <h2 className="text-xl">{batchTypeHuman}</h2>
          </div>
          {batch.batchType === "update_drill" ? (
            <UpdateDrillDetail
              batch={batch}
              fromRegistration={fromRegistration}
            />
          ) : (
            <UploadDrillDetail
              batch={batch}
              fromRegistration={fromRegistration}
            />
          )}
        </ContentBox>
      </div>
    );
  }

  const { dataTypeLabel, fileNamePrefix } = getMultiSectionBatchInfo(
    batch.batchType,
  );

  return (
    <div className="flex md:w-[90%] flex-col">
      <div className="py-5">
        <BreadcrumbsView items={breadcrumbItems} />
      </div>
      <ContentBox className="md:w-[80%] md:p-10">
        <div>
          <div className="flex items-center gap-6">
            <Icon className="h-[3rem] w-[3rem] text-gray-600" />
            <h2 className="text-xl">{batchTypeHuman}</h2>
          </div>
          <DownloadStatus
            batch={batch}
            dataTypeLabel={dataTypeLabel}
            fileNamePrefix={fileNamePrefix}
          />
        </div>
      </ContentBox>
    </div>
  );
};
